import { TraceModificationDTO } from './traceModificationDTO';

export class LogicalDeleteDTO extends TraceModificationDTO {
    deleteDate: Date;
    deleteUser: string;
}